import { observer } from "mobx-react-lite";
import ShopHistoryTable from "./components/ShopHistoryTable";

export default observer(function ShopUsagePage() {
    return (
        <>
            <ShopHistoryTable />
        </>
    );
});